import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from '../../../../base/BaseComponent';
import Picture from "../resourcePool/picture/Picture";

export default class FileLibrary extends BaseComponent {
    static defaultProps = {

    };
    static propTypes = {

    };

    constructor(props) {
        super(props);
        this.state = {   
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    firstWordToUpperCase= (word) => {
        return word.substring(0,1).toUpperCase()+word.substring(1);
    }

    render() {
        let {configName}=this.props;// picture
        let jsName = this.firstWordToUpperCase(configName); // 默认组件名就是文件夹名字首字母大写
        let File;
        if(typeof configName == "string"){
            File = require(`./${configName}/${jsName}`); // 引入
        }
        return (
            File?
            <File.default file={this.props.file} IsDownLoad={this.props.IsDownLoad} onDownloadCall={this.props.onDownloadCall} checked={this.props.checked}
                          onClick={()=>this.props.onClick()}
                          applyDownload={()=>{this.props.applyDownload&&this.props.applyDownload()}}
                          IsChecked={(e)=>{this.props.IsChecked&&this.props.IsChecked(e)}}/>
            :<div>文件未找到</div>
        )
    }

 
}
